import { LogOut, Home } from "lucide-react";
import { ProjectSelector } from "./ProjectSelector";
import { ModelSelector } from "./ModelSelector";
import { ThemeToggle } from "./ThemeToggle";
import { VersionBanner } from "./VersionBanner";
import { SecurityButton } from "../security/SecurityButton";
import { SecurityNotices } from "../security/SecurityNotices";
import { Button } from "../ui/button";

export function AppShell({
  projects,
  selectedProjectId,
  onSelectProject,
  onGoHome,
  modelValue,
  onModelChange,
  sidebar,
  children,
  onLogout,
  versionBannerProps,
}) {
  return (
    <div data-testid="app-shell" className="flex flex-col h-screen bg-background text-foreground">
      <VersionBanner {...versionBannerProps} />
      <header className="h-14 shrink-0 border-b border-border flex items-center justify-between px-4 gap-3">
        <div className="flex items-center gap-3">
          {onGoHome && (
            <Button data-testid="go-home-button" variant="ghost" size="icon" onClick={onGoHome}>
              <Home className="h-4 w-4" />
            </Button>
          )}
          <span className="font-mono text-sm font-semibold tracking-tight hidden sm:inline">
            Panel Orquestador
          </span>
          <ProjectSelector projects={projects} selectedProjectId={selectedProjectId} onSelect={onSelectProject} />
          {onModelChange && <ModelSelector value={modelValue} onChange={onModelChange} />}
        </div>
        <div className="flex items-center gap-1">
          <SecurityButton />
          <ThemeToggle />
          <Button data-testid="logout-button" variant="ghost" size="icon" onClick={onLogout}>
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </header>
      <SecurityNotices />
      <div className="flex flex-1 overflow-hidden">
        <aside className="w-64 shrink-0 border-r border-border hidden md:flex">{sidebar}</aside>
        <main className="flex-1 flex flex-col overflow-hidden">{children}</main>
      </div>
    </div>
  );
}
